export const enum UserRoles {
  Administrator = 'Administrator',
  SuperAdmin = 'Super Admin',
  TeamLead = 'Team Lead',
  HealtCareWorker = 'Community Health Worker',
}
